<template>




</template>

<script>
export default {
  name: "Footer",
  data() {
    return {}
  },
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    // today year
  },
  computed: {
    getYear() {
      return new Date().getFullYear();
    }
  }
}
</script>
<style>

</style>
<style scoped>

.footer {
  background-color: #eaebe8;
  padding-bottom: 0;
}

.logo {
  width: 75px;
  height: 75px;
}

.about {
  color: #2c3e50;
}

.gray-line {
  color: #a5a6a3;
}

#st-1 .st-btn[data-network='whatsapp'] {
  background-color: #b5b6b3;
}

#st-1 .st-btn[data-network='instagram'] {
  background-color: #b5b6b3;
}

#st-1 .st-btn[data-network='sharethis'] {
  background-color: #b5b6b3;
}

#st-1 .st-btn[data-network='facebook'] {
  background-color: #b5b6b3;
}

#st-1 .st-btn {
  box-sizing: border-box;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  margin-right: 8px;
  padding: 0 10px;
  position: relative;
  text-align: center;
  top: 0;
  vertical-align: top;
  white-space: nowrap;
}

.m {
  margin: 1rem;
}

.copy-color {
  background-color: rgba(0, 0, 0, 0.2);
}

.gototop {
  right: 30px;
  left: auto;
  padding-top: 5px;
  z-index: 299;
  position: fixed;
  width: 40px;
  height: 40px;
  background-color: var(--primary);
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  top: auto;
  bottom: 50px;
  cursor: pointer;
  border-radius: 50px;
}

</style>